import { render } from "./subMenu.vue?vue&type=template&id=239eb0b7&scoped=true"
import script from "./subMenu.vue?vue&type=script&lang=js"
export * from "./subMenu.vue?vue&type=script&lang=js"

import "./subMenu.vue?vue&type=style&index=0&id=239eb0b7&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-239eb0b7"]])

export default __exports__